// modifer: styles/jss/nextjs-material-kit-pro/pages/componentsSections/pillsStyle
import { section, container } from 'styles/jss/original/base';

const styles = {
  section: {
    ...section,
    padding: '0',
    '@media (max-width: 640px)': {
      padding: '0'
    }
  },
  container
};

export default styles;
